import React from "react";
import { Link } from "react-router-dom";
import { Building2, ArrowRight, ShieldCheck, RefreshCw, ClipboardCheck } from "lucide-react";
import SEO from "../../components/site/SEO";

const cases = [
  { name: "Brickyard District Storefronts", detail: "12-suite retail block, quarterly sidewalk + storefront pressure washing." },
  { name: "Willamette Valley Medical", detail: "6-story clinic exterior — monthly night-shift soft-wash and walkway cleaning." },
  { name: "Hult Center Ancillary", detail: "Event-driven cleanings on 48-hour turnaround windows." },
];

export default function Commercial() {
  return (
    <>
      <SEO title="Commercial Property Washing — Wonder Washers" description="Route-based commercial pressure washing for Willamette Valley businesses. Storefronts, warehouses, and multi-family exteriors." canonical="[BOOKING_URL]/commercial" />
      <section className="relative py-24 md:py-28 px-6 md:px-12 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBnbGFzcyUyMHdpbmRvd3N8ZW58MHx8fHwxNzg1OTU2NDM4fDA&ixlib=rb-4.1.0&q=85" alt="Commercial building" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 ww-hero-overlay" />
        <div className="relative max-w-5xl mx-auto text-white">
          <div className="inline-flex items-center gap-2 text-xs font-subhead tracking-widest text-[color:var(--ww-gold)] uppercase mb-3"><Building2 className="h-4 w-4" /> Commercial</div>
          <h1 className="font-display uppercase text-5xl md:text-7xl leading-none">Route-based service.<br /> Zero surprises.</h1>
          <p className="mt-5 text-slate-100/90 max-w-2xl">Storefronts, warehouses, medical, hospitality, multi-family. We show up when we said, work quietly, and send you the invoice with the receipts.</p>
          <div className="mt-8"><Link to="/quote" className="ww-btn-primary inline-flex items-center gap-2">Request commercial estimate <ArrowRight className="h-4 w-4" /></Link></div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto py-16 px-6 md:px-12 grid md:grid-cols-3 gap-6">
        {[
          { icon: ShieldCheck, t: "$2M liability coverage", d: "Certificates on request, additional insured status available." },
          { icon: RefreshCw, t: "Recurring routes", d: "Weekly, monthly, or quarterly — auto-scheduled and auto-billed." },
          { icon: ClipboardCheck, t: "Photo reporting", d: "Before/after job photos and checklists delivered with every invoice." },
        ].map(({ icon: Icon, t, d }) => (
          <div key={t} className="ww-card p-7">
            <span className="h-11 w-11 rounded-md bg-[color:var(--ww-navy)] text-[color:var(--ww-gold)] inline-flex items-center justify-center"><Icon className="h-5 w-5" /></span>
            <h3 className="mt-4 font-display uppercase text-2xl text-[color:var(--ww-navy)]">{t}</h3>
            <p className="mt-2 text-slate-600 text-sm">{d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-6xl mx-auto pb-20 px-6 md:px-12">
        <h2 className="font-display uppercase text-4xl text-[color:var(--ww-navy)] mb-8">Recent commercial work</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {cases.map(c => (
            <div key={c.name} className="ww-card p-6">
              <div className="text-xs font-subhead tracking-widest text-[color:var(--ww-red)] uppercase mb-2">Case study</div>
              <div className="font-display uppercase text-xl text-[color:var(--ww-navy)] leading-tight">{c.name}</div>
              <p className="text-sm text-slate-600 mt-2">{c.detail}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
